module.exports = __webpack_public_path__ + "img/wechattu1.4bd8a4c2.png";